// Based on Zds source code
// Changes: Add STOP value to stop snow

class LetItSnow {

    PARTICLES_COLOR = "rgba(255, 255, 255, 0.3)"; // Color
    MAX_PARTICLES = 35; // Particles limits
    SPAWN_RATE = 100; // time (ms) between two particles spawns
    PARTICLES_SPEED = 16; // Base speed
    PARTICLES_SIZE = 2; // Base size
    TURBULENCES_X = 1; // Turbulences amount (X)
    TURBULENCES_Y = 0.5; // Turbulences amount (Y)
    TURBULENCES_SPEED = 1; // Turbulences speed
    MAX_TIMESHIFT = Math.PI / 3; // Max time shifting (turbulences) between two particles
    STOP = true;

    constructor(element) {
        this._parent = element;

        // Init canvas
        this._canvas = document.createElement("canvas");
        this._canvas.style.position = 'absolute';
        this._canvas.style.zIndex = -2;
        this._canvas.style.margin = 'auto';
        this._canvas.style.marginTop = '0px';
        this._canvas.style.pointerEvents = 'none';
        this._canvas.style.top = 0;
        this._canvas.style.left = 0;
        this._canvas.style.right = 0;
        this._canvas.style.bottom = 0;
        this._ctx = this._canvas.getContext("2d");

        // Set spawn time
        this._lastSpawn = this._lastLoop = Date.now();

        // Update canvas size to parent
        this.updateCanvasSize();

        // Append the canvas...
        this._parent.appendChild(this._canvas);

        // No particles by default
        this.particles = [];

        window.addEventListener("resize", this.updateCanvasSize.bind(this));
    }

    stop() {
        this.STOP = true;
    }

    start() {
        const previousValue = this.STOP;
        this.STOP = false;
        if (previousValue === true) {
            this.loop();
        }
    }

    updateCanvasSize() {
        const rect = this._parent.getBoundingClientRect();

        this.H = rect.height;
        this.W = rect.width;

        this._canvas.height = this.H;
        this._canvas.width = this.W;
    }

    spawnParticle() {
        this.particles.push({
            x: Math.random() * this.W,
            y: - this.PARTICLES_SIZE,
            d: Math.random() + 1, // Density (affects speed and size)
            s: Math.random() * this.MAX_TIMESHIFT // Time shift
        });
    }

    loop() {
        if (this.STOP) {
            this._ctx.clearRect(0, 0, this.W, this.H);
        } else {
            this.update();
            this.draw();
            requestAnimationFrame(this.loop.bind(this));
        }
    }

    update() {
        const now = Date.now();
        const delta = now - this._lastLoop;

        for (let i in this.particles) {
            let p = this.particles[i];
            p.y += (delta / 1000) * (this.PARTICLES_SPEED * p.d * (1.5 + Math.sin(now * this.TURBULENCES_SPEED / 1000 + p.s) * this.TURBULENCES_Y));
            p.x += (delta / 1000) * (this.PARTICLES_SPEED * p.d * (Math.cos(now * this.TURBULENCES_SPEED / 1000 + p.s) * this.TURBULENCES_X));

            if (p.y - (p.d * 4) > this.H || p.x - (p.d * 4) > this.W || p.x + (p.d * 4) < 0) {
                this.particles.splice(i, 1);
            }
        }

        if (this._lastSpawn <= now - this.SPAWN_RATE && this.particles.length < this.MAX_PARTICLES) {
            this._lastSpawn = now;
            this.spawnParticle();
        }

        this._lastLoop = now;
    }

    draw() {
        this._ctx.clearRect(0, 0, this.W, this.H);

        this._ctx.fillStyle = this.PARTICLES_COLOR;
        this._ctx.beginPath();

        for (const p of this.particles) {
            this._ctx.moveTo(p.x, p.y);
            this._ctx.arc(p.x, p.y, p.d * this.PARTICLES_SIZE, 0, Math.PI * 2, true);
        }

        this._ctx.fill();
    }
}

export default LetItSnow;
